import {withRouter} from 'react-router';
import {query} from 'api';
import {withProps} from 'recompose';
import BaseRecipe from './BaseRecipe';

export default BaseRecipe
  |> query('getPost')
  |> withProps(
    ({
      match: {
        params: {id},
      },
    }) => ({type: 'recette_club', id}),
  )
  |> withRouter;
